namespace Gamification.Gamification {
    export interface UtentiApiRow {
        IdUtenteApi?: number;
        UserId?: number;
        IdApi?: number;
        Bloccato?: boolean;
        UserUsername?: string;
        UserDisplayName?: string;
        UserEmail?: string;
        UserSource?: string;
        UserLastDirectoryUpdate?: string;
        UserUserImage?: string;
        UserInsertDate?: string;
        UserInsertUserId?: number;
        UserUpdateDate?: string;
        UserUpdateUserId?: number;
        UserIsActive?: number;
        UserMobilePhoneNumber?: string;
        UserMobilePhoneVerified?: boolean;
        UserTwoFactorAuth?: number;
        IdApiNome?: string;
        IdApiDescrizione?: string;
    }

    export namespace UtentiApiRow {
        export const idProperty = 'IdUtenteApi';
        export const localTextPrefix = 'Gamification.UtentiApi';
        export const lookupKey = 'Gamification.UtentiApi';

        export function getLookup(): Q.Lookup<UtentiApiRow> {
            return Q.getLookup<UtentiApiRow>('Gamification.UtentiApi');
        }
        export const deletePermission = 'Gamification:Configurazione';
        export const insertPermission = 'Gamification:Configurazione';
        export const readPermission = 'Gamification:Configurazione';
        export const updatePermission = 'Gamification:Configurazione';

        export declare const enum Fields {
            IdUtenteApi = "IdUtenteApi",
            UserId = "UserId",
            IdApi = "IdApi",
            Bloccato = "Bloccato",
            UserUsername = "UserUsername",
            UserDisplayName = "UserDisplayName",
            UserEmail = "UserEmail",
            UserSource = "UserSource",
            UserLastDirectoryUpdate = "UserLastDirectoryUpdate",
            UserUserImage = "UserUserImage",
            UserInsertDate = "UserInsertDate",
            UserInsertUserId = "UserInsertUserId",
            UserUpdateDate = "UserUpdateDate",
            UserUpdateUserId = "UserUpdateUserId",
            UserIsActive = "UserIsActive",
            UserMobilePhoneNumber = "UserMobilePhoneNumber",
            UserMobilePhoneVerified = "UserMobilePhoneVerified",
            UserTwoFactorAuth = "UserTwoFactorAuth",
            IdApiNome = "IdApiNome",
            IdApiDescrizione = "IdApiDescrizione"
        }
    }
}
